/**
 * Shoppable Videos Section
 * GSAP-powered animations with shared MediaViewer
 */

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-shoppable-videos-section]');
  
  sections.forEach(section => {
    initShoppableVideos(section);
  });
});

function initShoppableVideos(section) {
  const container = section.querySelector('[data-videos-container]');
  const viewer = section.querySelector('.media-viewer');
  
  if (!viewer) {
    console.warn('Shoppable Videos: No media viewer found in section');
    return;
  }
  
  // Initialize Lucide icons
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  }
  
  // Initialize GSAP animations
  initEntranceAnimations(section);
  
  // Initialize carousel and click handlers
  initCarousel(container, section, viewer);
  
  // Initialize marquee detection for minimal product cards
  initMarqueeDetection(section);
}

// ===== GSAP Entrance Animations =====

function initEntranceAnimations(section) {
  // Wait for GSAP if not loaded yet
  if (typeof gsap === 'undefined') {
    if (window.gsapReady) {
      window.gsapReady.then(() => initEntranceAnimations(section));
    } else {
      setTimeout(() => initEntranceAnimations(section), 100);
    }
    return;
  }
  
  const cards = section.querySelectorAll('[data-shoppable-card]');
  const headings = section.querySelectorAll('.heading-block, .text-block');
  
  gsap.set(cards, { 
    opacity: 0, 
    y: 60,
    scale: 0.9
  });
  
  gsap.set(headings, {
    opacity: 0,
    y: 30
  });
  
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 80%',
      once: true
    }
  });
  
  tl.to(headings, {
    opacity: 1,
    y: 0,
    duration: 0.8,
    ease: 'power3.out',
    stagger: 0.1
  });
  
  tl.to(cards, {
    opacity: 1,
    y: 0,
    scale: 1,
    duration: 0.8,
    ease: 'power3.out',
    stagger: {
      amount: 0.6,
      from: 'start'
    }
  }, '-=0.4');
}

// ===== Marquee Detection =====

function initMarqueeDetection(section) {
  const titleWrappers = section.querySelectorAll('[data-title-wrapper]');
  const priceWrappers = section.querySelectorAll('[data-price-wrapper]');
  
  titleWrappers.forEach(wrapper => {
    const title = wrapper.querySelector('[data-title]');
    if (!title) return;
    
    const checkOverflow = () => {
      const titleText = title.querySelector('.minimal-product-card__title-text');
      if (titleText && titleText.scrollWidth > wrapper.clientWidth) {
        wrapper.classList.add('is-overflowing');
      } else {
        wrapper.classList.remove('is-overflowing');
      }
    };
    
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  });
  
  priceWrappers.forEach(wrapper => {
    const track = wrapper.querySelector('[data-price-track]');
    if (!track) return;
    
    const checkOverflow = () => {
      const priceText = track.querySelector('.minimal-product-card__price-text');
      if (priceText && priceText.scrollWidth > wrapper.clientWidth) {
        wrapper.classList.add('is-overflowing');
      } else {
        wrapper.classList.remove('is-overflowing');
      }
    };
    
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  });
}

// ===== Carousel =====

function initCarousel(container, section, viewer) {
  const carousel = container.querySelector('[data-carousel]');
  const track = container.querySelector('[data-track]');
  const cards = section.querySelectorAll('[data-shoppable-card]');
  
  if (cards.length === 0) {
    console.warn('Shoppable Videos: No cards found');
    return;
  }
  
  // Build media items array for the viewer from card JSON data
  const mediaItems = [];
  const cardDataArray = [];
  
  cards.forEach((card, index) => {
    const dataEl = card.querySelector('.shoppable-video-card__data');
    let cardData = null;
    
    if (dataEl) {
      try {
        cardData = JSON.parse(dataEl.textContent);
      } catch (e) {
        cardData = null;
      }
    }
    cardDataArray.push(cardData);
    
    if (cardData) {
      mediaItems.push({
        type: cardData.mediaType || 'image',
        videoSrc: cardData.videoSrc || null,
        externalUrl: cardData.externalUrl || null,
        poster: cardData.poster || '',
        imageSrc: cardData.poster || '', // For image-only cards
        cardData: cardData
      });
    }
  });
  
  // Open viewer on card click
  cards.forEach((card, index) => {
    const media = card.querySelector('[data-open-modal]');
    if (media) {
      media.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openViewer(index);
      });
    }
  });
  
  function openViewer(index) {
    if (typeof window.MediaViewer === 'undefined') {
      console.error('MediaViewer not loaded');
      return;
    }
    
    // Get product card elements from viewer
    const productCard = viewer.querySelector('[data-viewer-product]');
    const productLink = viewer.querySelector('[data-viewer-product-link]');
    const productImage = viewer.querySelector('[data-viewer-product-image]');
    const titleText = viewer.querySelector('[data-viewer-title-text]');
    const titleTextDupe = viewer.querySelector('[data-viewer-title-text-dupe]');
    const titleWrapper = viewer.querySelector('[data-viewer-title-wrapper]');
    const priceEl = viewer.querySelector('[data-viewer-price]');
    const comparePriceEl = viewer.querySelector('[data-viewer-compare-price]');
    
    function updateProductCard(cardIndex, item) {
      const data = cardDataArray[cardIndex];
      if (!data) return;
  
  // Get border radius from card
      const card = cards[cardIndex];
      if (card && productCard) {
  const cardRadius = getComputedStyle(card).getPropertyValue('--card-radius') || '20px';
        productCard.style.setProperty('--viewer-card-radius', cardRadius);
      }
      
      if (productLink && data.productUrl) {
        productLink.href = data.productUrl;
    }
      if (productImage && data.productImage) {
        productImage.innerHTML = `<img src="${data.productImage}" alt="${data.productTitle}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
    }
      if (titleText) {
        titleText.textContent = data.productTitle;
    }
      if (titleTextDupe) {
        titleTextDupe.textContent = data.productTitle;
    }
      if (titleWrapper && titleText) {
              setTimeout(() => {
          if (titleText.scrollWidth > titleWrapper.clientWidth) {
            titleWrapper.classList.add('is-overflowing');
          } else {
            titleWrapper.classList.remove('is-overflowing');
          }
              }, 50);
            }
      if (priceEl) {
        priceEl.textContent = data.price;
        if (data.onSale) {
          priceEl.classList.add('minimal-product-card__price--sale');
        } else {
          priceEl.classList.remove('minimal-product-card__price--sale');
        }
      }
      if (comparePriceEl) {
        comparePriceEl.textContent = data.comparePrice || '';
      }
    }
    
    window.MediaViewer.open({
      viewer: viewer,
      mediaItems: mediaItems,
      startIndex: index,
      onNavigate: updateProductCard
    });
    
    // Update product card for initial index
    updateProductCard(index, mediaItems[index]);
  }
}
